import React, { useEffect } from 'react';

import { useToggle, useAutoFocus } from 'hooks';
import { Icon, ActionList, ButtonGroup, Button, Popover } from 'ui';
import Modal from 'components/shared/modal';

const DeleteButton = ({ onDelete, isPublishing, isDeleting, isLinked }) => {
  const [modalVisible, toggleModalVisible] = useToggle();
  const [popoverVisible, togglePopoverVisible] = useToggle();
  const autoFocus = useAutoFocus();
  const isDisabled = isPublishing || isDeleting;

  useEffect(() => {
    if (modalVisible && isDisabled) {
      toggleModalVisible();
    }
  }, [toggleModalVisible, modalVisible, isDisabled]);

  return (
    <>
      <Popover
        activator={
          <button
            type="button"
            className="u-resetBtn c-brand-gray h-c-gray-darker fz-20 ml-12"
            disabled={isDisabled}
            onClick={togglePopoverVisible}
          >
            <Icon name="ellipsis-v" />
          </button>
        }
        visible={popoverVisible}
        position="top"
        align="right"
        onClose={togglePopoverVisible}
      >
        <div className="bs-3 mb-4">
          <ActionList
            items={[
              {
                disabled: isDisabled,
                buttonClassName: 'c-brand-gray-darker',
                iconClassName: 'c-brand-gray-darker',
                icon: 'delete',
                content: t('element_builder.delete'),
                onClick: toggleModalVisible,
              },
            ]}
          />
        </div>
      </Popover>
      <Modal
        show={modalVisible}
        dismissCallback={toggleModalVisible}
        title={
          isLinked
            ? t('element_builder.delete_confirmation.linked.title')
            : t('element_builder.delete_confirmation.template.title')
        }
      >
        {!isLinked && (
          <div className="mb-24">
            {t('element_builder.delete_confirmation.template.description')}
          </div>
        )}
        {isLinked && (
          <div className="mb-24">
            <b>
              {t('element_builder.delete_confirmation.linked.unlink_title')}
            </b>
            <div className="fs-i">
              {t(
                'element_builder.delete_confirmation.linked.unlink_description',
              )}
            </div>
          </div>
        )}
        <ButtonGroup alignEnd>
          <Button primary ref={autoFocus} onClick={toggleModalVisible}>
            {t('common.cancel')}
          </Button>
          <Button onClick={onDelete}>{t('element_builder.delete')}</Button>
        </ButtonGroup>
      </Modal>
    </>
  );
};

export default DeleteButton;
